export default "__VITE_ASSET__CCGC3DTr__"